const VersusIcon = /*#__PURE__*/ [
  ["path", { d: "M16 4L6 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 4L7 12L11 4", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M19 13.5V13C19 12.4477 18.5523 12 18 12H15C14.4477 12 14 12.4477 14 13V15C14 15.5523 14.4477 16 15 16H18C18.5523 16 19 16.4477 19 17V19C19 19.5523 18.5523 20 18 20H15C14.4477 20 14 19.5523 14 19V18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export { VersusIcon as default };
//# sourceMappingURL=VersusIcon.js.map
